// extracted by mini-css-extract-plugin
export default {"productsContainer":"gsnUL","productsList":"A9bIL"};